import React, { useContext, useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";

import { AppRoutes } from "../../constants/appRoutes";
import BranchFormPage from "./BranchFormPage";
import BusinessIcon from "@mui/icons-material/Business";
import DashboardIcon from "@mui/icons-material/Dashboard";
import EditIcon from "@mui/icons-material/Edit";
import { LoadingContext } from "../../context/contextProvider";
import { Navigate } from "react-router-dom";
import Services from "../../services/services";
import { ThemeColorsEnum } from "../../constants/enums";
import useCurrentUserInfo from "../../hooks/useCurrentUserInfo";

const breadcrumbs = [
  {
    IconComponent: DashboardIcon,
    title: "Dashboard",
    to: AppRoutes.dashboard,
  },
  {
    IconComponent: BusinessIcon,
    title: "Branches",
    to: AppRoutes.products,
  },
  {
    IconComponent: EditIcon,
    title: "Edit",
  },
];

const BranchEditPage = (props) => {
  const { id } = useParams();
  const { state } = useLocation();

  const [branch, setBranch] = useState(state?.branch);

  const { setLoading } = useContext(LoadingContext);

  const userInfo = useCurrentUserInfo();

  useEffect(() => {
    if (id && !state?.branch) getBranchAsync(id);
  }, [id, state]); // eslint-disable-line react-hooks/exhaustive-deps

  const getBranchAsync = async (id) => {
    setLoading(true);
    const response = await Services.api.clients.get(id);
    setLoading(false);

    if (!response.ok)
      return Services.utility.toast(
        "Could not fetch the branch",
        ThemeColorsEnum.error
      );

    setBranch(response.data);
  };

  if (!userInfo?.isAdmin)
    return (
      <Navigate
        to={{
          pathname: AppRoutes.forbidden,
        }}
      />
    );

  return (
    <BranchFormPage
      breadcrumbs={breadcrumbs}
      branch={branch}
      title="Branches - Edit"
    ></BranchFormPage>
  );
};

export default BranchEditPage;
